import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import historyIcon from "../../../assets/images/history-icon.svg";
import FormButton from "../../../Components/Buttons/FormButton";
import CustomizableTableForAddAndEdit from "../../../Components/Tables/CustomizableTableForAddAndEdit";
import PageHeader from "../../../Layout/PageHeader";
import { DataFromAPI, dropDownFromList, dropDownItemCode, dropDownToList, HistoryLaoutDataTransferEdit, initialData, InvStatusList } from "../../../Data/testData";
import Select from 'react-select'
import HistoryLayout from "../../../Layout/HistoryLaout";

export default function TransferEdit() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const pageName = `Stock Transfer`;
  const [isShowCanvas, setShowCanvas] = useState(false);
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      // minHeight: '30px', // Adjust the minimum height of the input box
      // height: '30px',    // Set the height of the input box
      width: '125px !important',    // Set the width of the input box
      fontSize: '14px',  // Adjust font size if needed
      padding: 0
    }), menu: (provided: any) => ({
      ...provided,
      width: '125px',    // Set the width of the dropdown menu
    }),

  };

  const customStylesForInvStats = {
    control: (provided: any) => ({
      ...provided,
      // minHeight: '30px', // Adjust the minimum height of the input box
      // height: '30px',    // Set the height of the input box
      width: '130px !important',    // Set the width of the input box
      fontSize: '14px',  // Adjust font size if needed
    }), menu: (provided: any) => ({
      ...provided,
      width: '130px',    // Set the width of the dropdown menu
    }),
  };


  const handelCanvas = () => {
   setShowCanvas(!isShowCanvas);
  };

  const backNavigate = () => {
    return navigate(`/inventory/stock-transfer/transfer-details/${id}`);
  }

  const handleClose = () => {
    backNavigate();
  }

  const save = () => {
    backNavigate();
  }
  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );


  const columns = [
    { key: 'lineNumber', label: 'Line #', disable: true },
    { key: 'itemCode', label: 'Item Code', inputType: <Select options={dropDownItemCode} styles={customStyles} />, disable: true },
    { key: 'itemDescription', label: 'Item Description', disable: true, customStyles: { width: '182px' } },
    { key: 'uom', label: 'UOM', disable: true },
    { key: 'from', label: 'From', inputType: <Select options={dropDownFromList} styles={customStyles} /> },
    { key: 'to', label: 'To', inputType: <Select options={dropDownToList} styles={customStyles} /> },
    { key: 'transferQty', label: 'Transfer Qty', disable: true, customStyles: { width: '110px' } },
    { key: 'invStatus', label: 'Inv Status', inputType: <Select options={InvStatusList} styles={customStylesForInvStats} />, customStyles: { width: '160px' } },

  ];

  return (
    <>
      <PageHeader

        listUrl="/inventory/stock-transfer"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}

      />


      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 px-2">
        <div className="checkin-details col-12 bg-white col-12 py-1 py-4 px-3 ">
          <div className="row gap-3">
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">Transfer Date</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="date"

                  name="name"
                  className={`form-control`}
                  placeholder="Enter Title"
                //   onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">From Inventory Status</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"
                  name="name"
                  className={`form-control`}
                  placeholder="Enter Title"
                //   onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="row gap-3">
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">To Inventory Status</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"

                  name="name"
                  className={`form-control`}
                  placeholder="Enter Title"
                //   onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">Custom Field 1</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"

                  name="name"
                  className={`form-control`}
                  placeholder="Enter Title"
                //   onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="row gap-3">
            <div className="col-5 px-2 mb-3">
              <label className="fw-medium">Custom Field 2</label>
              <div className="mt-1">
                <input
                  tabIndex={1}
                  autoFocus={true}
                  maxLength={50}
                  type="text"

                  name="name"
                  className={`form-control`}
                  placeholder="Enter Title"
                //   onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-2 bg-white rounded py-1 px-2 CustomizedTable">
        <CustomizableTableForAddAndEdit
        columns={columns} initialData={initialData} 
        customClassName="tranferEditCustomTable" dataFromAPI={DataFromAPI} filterColumn="itemCode" />
      </div>
      <div className="my-2 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={25}
            className="sph-btn me-4"
            handleClick={() => handleClose()}>

            Submit
          </FormButton>
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift me-4"
            handleClick={() => handleClose()}>
            Cancel
          </FormButton>
        </div>
      </div>


      <HistoryLayout showViewScanLogs={true}  isShowCanvas={isShowCanvas} handelCanvas={handelCanvas} data={HistoryLaoutDataTransferEdit} />
    </>
  );
}
